import { fetchJSON } from '../utils/fetchJSON'

const WP_BASE = 'https://cms.modlingroup.dbox.com/index.php/wp-json/wp/v2'

const LISTINGS_URL = 'https://residences.api.dbox.com/perchwell/modlin-group?projectname=modlin'

export const parseWordpressRes = (arr) => {
  if (!Array.isArray(arr)) return []
  return arr.map((el) => {
    const acf = el?.acf || {}
    return { id: el?.id, ...acf }
  })
}

export async function getTeam ({ signal } = {}) {
  const data = await fetchJSON(`${WP_BASE}/modlin_group_team?per_page=100`, { signal })
  return parseWordpressRes(data)
}

export async function getNews ({ signal } = {}) {
  const data = await fetchJSON(`${WP_BASE}/modlin_group_news?per_page=100`, { signal })
  return parseWordpressRes(data)
}

export async function getHomeSections ({ signal } = {}) {
  const data = await fetchJSON(`${WP_BASE}/home_page_sections?per_page=100`, { signal })
  return parseWordpressRes(data)
}

export async function getListings ({ signal, timeoutMs = 15000 } = {}) {
  const json = await fetchJSON(LISTINGS_URL, { signal, timeoutMs })
  return Array.isArray(json) ? json : json?.data || []
}
